import React, { useState } from 'react';
import './Research.css';

const Research = () => {
  const [activeTab, setActiveTab] = useState('publications');

  const researchData = {
    publications: [
      {
        id: 1,
        title: "Implementation and Performance Comparison of Gradient Boosting Algorithms for Tabular Data Classification",
        journal: "SpringerLink, Algorithms for Intelligent Systems",
        year: "2024",
        category: "AI & Machine Learning"
      },
      {
        id: 2,
        title: "Digitalization in Agriculture Marketing: The Function of Big Data and AI in Government Programs",
        journal: "Journal of Propulsion Technology",
        year: "2025",
        category: "AI & Technology"
      },
      {
        id: 3,
        title: "Boosting Image-Text Detection Performance with Python Tesseract and the Tesseract OCR Engine",
        journal: "IEEE Xplore",
        year: "2024",
        category: "AI & Computer Vision"
      },
      {
        id: 4,
        title: "AI-Powered Fraud Detection in Financial Transactions: A Machine Learning Approach",
        journal: "Journal of Information Systems Engineering and Management",
        year: "2024",
        category: "AI & Finance"
      },
      {
        id: 5,
        title: "Ecological Imbalance: A Study of Impact of Climate Change on Indian Economy",
        journal: "Journal of Tongji University",
        year: "2023",
        category: "Economics"
      }
    ],
    patents: [
      {
        id: 1,
        title: "Generative AI Based Customer Feedback Kiosk",
        type: "Design Registration",
        status: "Registered",
        number: "449822-001",
        date: "2025"
      },
      {
        id: 2,
        title: "Method For Analyzing Emotions And Sentiments Of People During Corona Virus Pandemic",
        type: "Patent",
        status: "Published",
        date: "2023"
      }
    ],
    books: [
      {
        id: 1,
        title: "Financial Management and Market Dynamics",
        publisher: "Scientific International Publishing House",
        year: "2024",
        role: "Co-author"
      },
      {
        id: 2,
        title: "Social Media Marketing and Its Application",
        publisher: "Scientific International Publishing House",
        year: "2023",
        role: "Contributing Author"
      },
      {
        id: 3,
        title: "Industrial Economics",
        publisher: "Savera Publisher",
        year: "2012",
        role: "Co-author"
      }
    ]
  };

  return (
    <section className="research" id="research">
      <div className="container">
        <div className="research-header">
          <h2>Research & Publications</h2>
          <p>Contributions to AI, Finance, and Emerging Technologies</p>
        </div>

        <div className="stats">
          <div className="stat">
            <div className="number">{researchData.publications.length}+</div>
            <div className="label">Research Papers</div>
          </div>
          <div className="stat">
            <div className="number">{researchData.books.length}</div>
            <div className="label">Books</div>
          </div>
          <div className="stat">
            <div className="number">{researchData.patents.length}</div>
            <div className="label">Patents</div>
          </div>
        </div>

        <div className="tabs">
          <button 
            className={`tab ${activeTab === 'publications' ? 'active' : ''}`}
            onClick={() => setActiveTab('publications')}
          >
            Research Papers
          </button>
          <button 
            className={`tab ${activeTab === 'patents' ? 'active' : ''}`}
            onClick={() => setActiveTab('patents')}
          >
            Patents
          </button>
          <button 
            className={`tab ${activeTab === 'books' ? 'active' : ''}`}
            onClick={() => setActiveTab('books')}
          >
            Books
          </button>
        </div>

        <div className="content">
          {activeTab === 'publications' && (
            <div className="cards-grid">
              {researchData.publications.map((pub, index) => (
                <div key={pub.id} className="card">
                  <div className="card-header">
                    <div className="card-number">#{index + 1}</div>
                    <div className="card-category">{pub.category}</div>
                  </div>
                  <h3 className="card-title">{pub.title}</h3>
                  <div className="card-meta">
                    <span className="journal">{pub.journal}</span>
                    <span className="year">{pub.year}</span>
                  </div>
                </div>
              ))}
            </div>
          )}

          {activeTab === 'patents' && (
            <div className="cards-grid">
              {researchData.patents.map((patent, index) => (
                <div key={patent.id} className="card patent">
                  <div className="card-header">
                    <div className="card-number">#{index + 1}</div>
                    <div className={`status ${patent.status.toLowerCase()}`}>
                      {patent.status}
                    </div>
                  </div>
                  <h3 className="card-title">{patent.title}</h3>
                  <div className="card-details">
                    <div className="detail">
                      <span>Type:</span>
                      <strong>{patent.type}</strong>
                    </div>
                    {patent.number && (
                      <div className="detail">
                        <span>Number:</span>
                        <strong>{patent.number}</strong>
                      </div>
                    )}
                    <div className="detail">
                      <span>Date:</span>
                      <strong>{patent.date}</strong>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {activeTab === 'books' && (
            <div className="cards-grid">
              {researchData.books.map((book, index) => (
                <div key={book.id} className="card book">
                  <div className="card-header">
                    <div className="card-number">#{index + 1}</div>
                    <div className="role">{book.role}</div>
                  </div>
                  <h3 className="card-title">{book.title}</h3>
                  <div className="card-details">
                    <div className="detail">
                      <span>Publisher:</span>
                      <strong>{book.publisher}</strong>
                    </div>
                    <div className="detail">
                      <span>Year:</span>
                      <strong>{book.year}</strong>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Research;